module.exports = __webpack_public_path__ + "static/media/froglegs.df4ce08c.webp";